import vxApplicationAuth from '../components/common/vx-application-auth/vx-application-auth.vue';
import vxHeaderSection from '../components/b2c/common/vx-header-section/vx-header-section.vue';
import vxFlyoutBanner from '../components/common/vx-flyout-banner/vx-flyout-banner.vue';
import vxFooterSection from '../components/common/vx-footer-section/vx-footer-section.vue';
import vxVideoPlayer from '../components/common/vx-video-player/vx-video-player.vue';
import VxSectionTitle from '../components/common/vx-title/vx-title.vue';
import vxRichText from '../components/common/vx-rich-text/vx-rich-text.vue';
import vxJuicerFeed from '../components/common/vx-juicer-feed/vx-juicer-feed.vue';
import vxBreadcrumb from '../components/common/vx-breadcrumb/vx-breadcrumb.vue';
import vxCustomerDetails from '../components/common/vx-customer-details/vx-customer-details.vue';
import vxAssistiveText from '../components/common/vx-assistive-text/vx-assistive-text.vue';
import vxBundles from '../components/common/vx-bundles/vx-bundles.vue';

import vxMinimizedHeader from '../components/common/vx-minimized-header/vx-minimized-header.vue';
import vxLiveAgentBtn from '../components/common/vx-live-agent-btn/vx-live-agent-btn.vue';
import vxBazaarVoice from '../components/common/vx-bazaar-voice/vx-bazaar-voice.vue';
import vxFlyoutBannerSecondary from '../components/common/vx-flyout-banner-secondary/vx-flyout-banner-secondary.vue';
import vxMarketingForm from '../components/common/vx-marketing-form/vx-marketing-form.vue';
import vxContentStack from '../components/common/contentstack/vx-contentstack/vx-contentstack.vue';
import csArticle from '../components/common/contentstack/cs-article/cs-article.vue';
import initMixin from '../components/common/mixins/init-mixin';
import trackJSMixin from '../components/common/mixins/trackjs-mixin';

const commonModule = {
  components: {
    vxApplicationAuth,
    vxHeaderSection,
    vxFlyoutBanner,
    vxFooterSection,
    vxVideoPlayer,
    VxSectionTitle,
    vxRichText,
    vxJuicerFeed,
    vxBreadcrumb,
    vxCustomerDetails,
    vxAssistiveText,
    vxBundles,
    vxMinimizedHeader,
    vxBazaarVoice,
    vxFlyoutBannerSecondary,
    vxLiveAgentBtn,
    vxMarketingForm,
    vxContentStack,
    csArticle,
  },
  mixins: [
    initMixin,
    trackJSMixin,
  ],

};

export default commonModule;



// WEBPACK FOOTER //
// ./src/modules/common-b2c.js